/**
 * VideoUploadProgress Component
 * Modal overlay showing upload progress
 */

import type { VideoUploadProgress as ProgressType } from '../../../../../types/prospect-media';
import './VideoUploadProgress.css';

interface VideoUploadProgressProps {
  progress: ProgressType;
}

export function VideoUploadProgress({ progress }: VideoUploadProgressProps) {
  return (
    <div className="video-upload-progress__overlay">
      <div className="video-upload-progress__modal">
        <p className="video-upload-progress__message">{progress.message}</p>
        <div className="video-upload-progress__bar-container">
          <div
            className="video-upload-progress__bar"
            style={{ width: `${progress.percent}%` }}
          />
        </div>
      </div>
    </div>
  );
}
